enum EFetchCredentials {
    OMIT = 'omit',
}

export default EFetchCredentials
